<template>
  <b-navbar fixed-top centered>
    <template #brand>
      <b-navbar-item href="https://buzzbingo.com">
        <img
          src="../assets/images/logo.svg"
          alt="TV Tweets"
          class="image is-96x96 is-hidden-touch"
        />
        <img
          src="../assets/images/logo.svg"
          alt="TV Tweets"
          class="image is-64x64 is-hidden-desktop"
        />
      </b-navbar-item>
    </template>
    <template #burger>
      <b-navbar-item tag="div" class="is-hidden-desktop">
        <div class="field is-grouped">
          <p class="control">
            <a
              class="has-text-grey-dark"
              data-social-network="Twitter"
              data-social-action="tweet"
              data-social-target="https://buzzbingo.com"
              target="_blank"
              href="https://twitter.com/intent/tweet?text=Take a look at the Most Stressful TV Shows to Watch&amp;url=https://buzzbingo.com&amp;via=jgthms"
            >
              <span class="icon">
                <vue-fontawesome :icon="['fab', 'twitter']" />
              </span>
            </a>
          </p>

          <p class="control">
            <a
              class="has-text-grey-dark"
              data-social-network="Facebook"
              data-social-action="share"
              data-social-target="https://buzzbingo.com"
              target="_blank"
              href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.buzzbingo.com%2Fbingo-games%2Ftv-tweets%2F"
            >
              <span class="icon">
                <vue-fontawesome icon="share" />
              </span>
            </a>
          </p>
          <p class="control">
            <modal linkType="icon"></modal>
          </p>
        </div>
      </b-navbar-item>
    </template>
    <template #end>
      <b-navbar-item tag="div" class="is-hidden-touch">
        <div class="field is-grouped">
          <p class="control">
            <a
              class="bd-tw-button button has-text-grey-dark"
              data-social-network="Twitter"
              data-social-action="tweet"
              data-social-target="https://buzzbingo.com"
              target="_blank"
              href="https://twitter.com/intent/tweet?text=Does%20Love%20Island%20stress%20its%20viewers%20out%20more%20than%20any%20other%20show%20on%20television%3F%20We%E2%80%99ve%20analysed%20audience%20reactions%20on%20Twitter%20to%20find%20out%3A%20www.buzzbingo.com%2Fbingo-games%2Ftv-tweets-2021%2F%20via%20%40Buzz_Bingo"
            >
              <span class="icon">
                <vue-fontawesome :icon="['fab', 'twitter']" />
              </span>
              <span> Tweet </span>
            </a>
          </p>

          <p class="control">
            <a
              class="bd-tw-button button has-text-grey-dark"
              data-social-network="Facebook"
              data-social-action="share"
              data-social-target="https://buzzbingo.com"
              target="_blank"
              href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.buzzbingo.com%2Fbingo-games%2Ftv-tweets-2021%2F"
            >
              <span class="icon">
                <vue-fontawesome icon="share" />
              </span>
              <span> Share </span>
            </a>
          </p>
          <p class="control">
            <modal linkType="button"></modal>
          </p>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>
<script>
  import Modal from "@/components/Modal";
  export default {
    components: {
      Modal,
    },
  };
</script>
<style scoped></style>
